module.exports = __webpack_public_path__ + "img/svg/step5.8daa48388784aeaecf9fe6041859cfef.svg";